export default class FishStocking {
  static async getReports(filters = {}) {
    const params = new URLSearchParams();
    if (filters.region) params.append('region', filters.region);
    if (filters.days) params.append('days', filters.days);
    if (filters.search) params.append('search', filters.search);
    const query = params.toString();
    const url = `/fish_stocking${query ? '?' + query : ''}`;

    return new Promise((resolve, reject) => {
      return fetch(url, { method: "GET", headers: { Accept: "application/json" } })
        .then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async scrapeNow() {
    return new Promise((resolve, reject) => {
      return fetch('/fish_stocking/scrape', {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" }
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async getScrapeLog() {
    return new Promise((resolve, reject) => {
      return fetch('/fish_stocking/scrape_log', { method: "GET", headers: { Accept: "application/json" } })
        .then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }
}
